//@ts-nocheck
import React from "react";

/**
 * @see: https://hello.atlassian.net/browse/PUR-3356
 */
export const AdometryValidationDummyTag = () => {
    return (
        <>
            <script src="//js.dmtry.com/channel.js#gid:3968;advid:997;pid:857803" />
            <noscript>
                {/* eslint-disable-next-line no-restricted-syntax */}
                <img
                    width="0"
                    height="0"
                    src="//log.dmtry.com/redir/1/0/3968/857803/0/1/173/0/997/1.ver?at=v&d=PxConv"
                    alt="Adometry Validation Dummy Tag"
                />
            </noscript>
        </>
    );
};

export default AdometryValidationDummyTag;
